import { useEffect } from 'react';
import { Routes, Route, useSearchParams } from 'react-router-dom';
import AuthGuard from './components/AuthGuard';
import ShopifyAuth from './components/ShopifyAuth';
import Dashboard from './pages/Dashboard';

const TOKEN_KEY = 'listing_app_token';
const API_KEY_KEY = 'listing_app_api_key';

function TokenAuth() {
  const [searchParams, setSearchParams] = useSearchParams();
  const urlToken = searchParams.get('token');
  const urlApiKey = searchParams.get('apikey');

  useEffect(() => {
    if (urlApiKey) {
      sessionStorage.setItem(API_KEY_KEY, urlApiKey);
      sessionStorage.removeItem(TOKEN_KEY);
      setSearchParams({}, { replace: true });
    } else if (urlToken) {
      sessionStorage.setItem(TOKEN_KEY, urlToken);
      sessionStorage.removeItem(API_KEY_KEY);
      setSearchParams({}, { replace: true });
    }
  }, [urlToken, urlApiKey]); // eslint-disable-line  react-hooks/exhaustive-deps

  const apiKey = urlApiKey || sessionStorage.getItem(API_KEY_KEY);
  const token = urlToken || sessionStorage.getItem(TOKEN_KEY) || sessionStorage.getItem('utoken');

  if (!apiKey && !token) {
    return (
      <div className="centered-page">
        <div className="centered-box">
          <div className="icon-circle icon-circle--yellow">
            <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
            </svg>
          </div>
          <h1 className="heading-xl">Token Required</h1>
          <p className="text-muted">Access this page from your platform with a valid authentication token or API key.</p>
        </div>
      </div>
    );
  }

  return (
    <AuthGuard token={apiKey ? null : token} apiKey={apiKey || null}>
      {(store) => <Dashboard store={store} />}
    </AuthGuard>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/shopify-auth" element={<ShopifyAuth />} />
      <Route path="/*" element={<TokenAuth />} />
    </Routes>
  );
}
